import styled, { css } from "styled-components";
import { mediaMax } from "components/designV2/breakpoints";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";

export const Container = styled.div`
  display: flex;
  align-items: flex-start;
  flex-shrink: 0;
  min-width: 320px;
  column-gap: 12px;
  padding: 14px 16px;
  border-radius: 20px;
  background: ${ColorV2.White};

  ${mediaMax.mobileLarge} {
    min-width: 0;
    width: 100%;
    column-gap: 4px;
    padding: 10px 8px;
  }
`;

export const NavButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  align-self: center;
  border: none;
  background: transparent;
  cursor: pointer;

  &:disabled {
    cursor: default;
    opacity: 0.5;
  }
`;

export const PeriodButton = styled.button`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  min-width: 220px;
  gap: 4px;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;

  &:hover > span:first-child {
    color: ${ColorV2.Blue3};
  }

  ${mediaMax.mobileLarge} {
    min-width: 0;
  }
`;

export const MonthLabel = styled.span<{ $isSubLabel?: boolean }>`
  ${(props) => (props.$isSubLabel ? TypographyV2.s1 : TypographyV2.h3)}
  color: ${(props) => (props.$isSubLabel ? ColorV2.Blue4 : ColorV2.Blue1)};
  transition: color 150ms ease;
  white-space: nowrap;
`;

export const TodayButton = styled.button`
  ${TypographyV2.s1}
  flex-shrink: 0;
  align-self: flex-start;
  margin-top: 4px;
  padding: 8px 12px;
  border: 1px solid ${ColorV2.Blue2};
  border-radius: 999px;
  color: ${ColorV2.Blue2};
  background: ${ColorV2.White};
  cursor: pointer;

  &:hover:not(:disabled) {
    background: ${ColorV2.Blue7};
  }

  &:disabled {
    cursor: default;
    opacity: 0.5;
  }
`;

export const Popup = styled.div<{
  $left: number;
  $top: number;
  $zIndex: number;
  $isMeasured: boolean;
}>`
  position: fixed;
  top: ${(props) => props.$top}px;
  left: ${(props) => props.$left}px;
  width: min(264px, calc(100vw - 16px));
  padding: 12px;
  border: 1px solid ${ColorV2.Blue5};
  border-radius: 10px;
  background: ${ColorV2.White};
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  z-index: ${(props) => props.$zIndex};
  visibility: ${(props) => (props.$isMeasured ? "visible" : "hidden")};
`;

export const PopupHeader = styled.div`
  display: grid;
  grid-template-columns: 32px 1fr 32px;
  align-items: center;
  column-gap: 8px;
  margin-bottom: 8px;
`;

export const PopupYear = styled.span`
  ${TypographyV2.b2}
  text-align: center;
  color: ${ColorV2.Blue1};
`;

export const YearNavButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 1px solid ${ColorV2.Blue6};
  border-radius: 8px;
  background: ${ColorV2.White};
  cursor: pointer;

  &:hover:not(:disabled) {
    background: ${ColorV2.Blue7};
  }

  &:disabled {
    cursor: default;
  }
`;

export const MonthGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 4px 8px;
`;

export const MonthButton = styled.button<{ $isSelected: boolean }>`
  ${TypographyV2.b2}
  min-height: 38px;
  padding: 8px 10px;
  border: none;
  border-radius: 8px;
  color: ${ColorV2.Blue1};
  background: transparent;
  cursor: pointer;

  &:hover:not(:disabled) {
    background: ${ColorV2.Blue7};
  }

  &:disabled {
    cursor: default;
    opacity: 0.5;
  }

  ${(props) =>
    props.$isSelected &&
    css`
      color: ${ColorV2.White};
      background: ${ColorV2.Blue1};

      &:hover {
        background: ${ColorV2.Blue1};
      }
    `}
`;
